<template>
    <div class="otp-select">
        <el-select v-model="cValue" @input="sendSelectValue" @clear="clear(cValue)" :multiple="multiple"
        :filterable="filterable" :disabled="disabled" :placeholder="placeholder" :clearable="clearable" v-bind="$attrs">
            <el-option
                v-for="(item,index) in (!optionSort ? options : _options)"
                v-show="showDisabledOptions || !disabledOptions.includes(item.value)"
                :key="index"
                :disabled="disabledOptions.includes(item.value)"
                :label="item.label"
                :value="item.value"
            ></el-option>
        </el-select>
    </div>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api';
export default {
    data() {
        return {
            options: [],
            cValue: ''
        };
    },
    props: {
        url: String,
        optionArr: Array,
        optionNum: String,
        placeholder: String,
        multiple: Boolean,
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: Boolean,
        value: {
            type: [String, Number, Array]
        },
        clearable: {
            type: Boolean,
            default: true
        },
        disabledOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        // 是否显示禁选项, 默认显示
        showDisabledOptions: {
            type: Boolean,
            default: true
        },
        // 指定排序
        optionSort: {
            default() {
                return false;
            }
        }
    },
    computed: {
        // 按照optionSort指定的value的顺序显示下拉选项
        _options({options}) {
            try{
                // 1. 下拉框按optionSort给的顺序排序
                // 2. optionSort没给的值, 放在最后, 保持原本的顺序
                // 分离在optionSort中的项和不在optionSort中的项
                const inSort = [];
                const notInSort = [];
                
                options.forEach(item => {
                    const index = this.optionSort.indexOf(item.value);
                    if (index !== -1) {
                        inSort.push({ item, index });
                    } else {
                        notInSort.push(item);
                    }
                });
                
                // 对在optionSort中的项按index排序
                inSort.sort((a, b) => a.index - b.index);
                
                // 合并：先是在optionSort中的项（已排序），然后是不在optionSort中的项（保持原序）
                return [...inSort.map(i => i.item), ...notInSort];
            } catch(error){
                return options; 
            }
        }
    },
    watch: {
        value(val) {
            this.cValue = val;
        },
        optionNum(val) {
            this.getDictionary();
        },
        // 2025/11/11 修复optionArr改变没渲染更新的问题
        optionArr(val) {
            this.getDictionary();
        }
    },
    methods: {
        getDictionary() {
            if (this.optionNum) {
                dictWithUrl(this.optionNum, this.url).then(res => {
                    if (res.code === '0') {
                        const arr = [];
                        for (const key in res.data[this.optionNum]) {
                            if (res.data[this.optionNum].hasOwnProperty(key)) {
                                arr.push({
                                    value: key,
                                    label: res.data[this.optionNum][key]
                                });
                            }
                        }
                        this.options = arr;
                    }
                });
            } else {
                this.options = this.optionArr;
            }
        },
        sendSelectValue(val) {
            let label = '';
            this.options.map(item => {
                if (item.value === this.cValue) {
                    label = item.label;
                }
            });
            this.$emit('input', val);
            this.$emit('getSelectLabel', label);
            setTimeout(() => {
                this.$emit('change');
            }, 50);
        },
        clear(value) {
            this.$emit('clear', this.cValue);
        }
    },
    created() {
        this.getDictionary();
        this.cValue = this.value;
    }
};
</script>

<style lang="less">
    .otp-select{
        width:100%;
        .el-select{
            width:100%;
        }
    }
</style>
